<template>
  <Snackbar
    ref="snackbar"
    :oneTimeOnly="true"
    :localKey="'wechat_dashboard_banner'"
    class="d-flex drag-noevents w-100"
    style="
      --position: relative;
      --clr-back: var(--clr-primary-1);
      gap: 1rem;
      padding: 0.5rem 1rem;
      --close-inset: 0rem 0rem auto auto;
      max-width: 100%;
    "
  >
    <a
      href="https://mp.weixin.qq.com/s?__biz=Mzg3NTY3Mzc1Mg==&mid=2247484703&idx=1&sn=befdf39ba20dcabe90078f1665acc3fd&chksm=cf3ca4e8f84b2dfe726b9a94261af0dd49231d589750ab4e8868e900d436a06ce2eda0842e20&token=40996548&lang=zh_CN#rd"
      target="_blank"
      class="f-center w-100 clr-white text-underline text-underline_hover"
      style="border-radius: 8px; margin: 0 1rem"
    >
      <!-- loose translation -  Scan this QR code and be invited to our WeChat group -->
      <div class="pr-6 text-large weight_500">扫描此二维码添加工作人员，受邀进入我们的微信群</div>
      <img
        :src="getImage('wechatqrcode.webp')"
        style="height: 3cm; border-radius: 8px"
      />
    </a>
  </Snackbar>
</template>

<script>
import Snackbar from '@/components/Messages/Snackbar'

export default {
  name: 'WeChatSnackbar',
  components: {
    Snackbar,
  },
  props: {},
  data() {
    return {}
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/img/${img}`, import.meta.url).href
    },
  },
}
</script>
